/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_1_DescInputs */

const en_mk_agent_1_desc = /** @type {(inputs: Mk_Agent_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask what is left in phase 2, which tasks touch auth, or why a feature exists. It reads the plan, not a chat log.`)
};

const id_mk_agent_1_desc = /** @type {(inputs: Mk_Agent_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanya apa yang tersisa di fase 2, task mana yang menyentuh auth, atau kenapa sebuah fitur ada. Ia membaca rencana, bukan log chat.`)
};

/**
* | output |
* | --- |
* | "Ask what is left in phase 2, which tasks touch auth, or why a feature exists. It reads the plan, not a chat log." |
*
* @param {Mk_Agent_1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_1_desc = /** @type {((inputs?: Mk_Agent_1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_1_desc(inputs)
	return en_mk_agent_1_desc(inputs)
});